/** Work order types shown in planning filters and bulk actions */
export const PLANNING_WORK_TYPE_OPTIONS = [
  { key: 'installation', label: 'Installatie' },
  { key: 'measurement', label: 'Inmeting' },
  { key: 'service', label: 'Service' },
];

export const ALL_PLANNING_WORK_TYPE_KEYS = PLANNING_WORK_TYPE_OPTIONS.map((t) => t.key);

export const getWorkOrderTypeLabel = (type) => {
  const key = type || 'installation';
  return PLANNING_WORK_TYPE_OPTIONS.find((t) => t.key === key)?.label || key;
};

export const DEFAULT_WORK_TIME = {
  workday_start: '08:00',
  workday_end: '17:00',
  break_minutes_between_jobs: 15,
  timezone: 'Europe/Amsterdam',
};

/** Resolve work time config from organization settings with defaults */
export const getPlanningWorkTime = (organization) => {
  const fromOrg = organization?.settings?.planning_work_time;
  if (!fromOrg || typeof fromOrg !== 'object') {
    return { ...DEFAULT_WORK_TIME };
  }
  return {
    workday_start: fromOrg.workday_start || DEFAULT_WORK_TIME.workday_start,
    workday_end: fromOrg.workday_end || DEFAULT_WORK_TIME.workday_end,
    break_minutes_between_jobs:
      fromOrg.break_minutes_between_jobs ?? DEFAULT_WORK_TIME.break_minutes_between_jobs,
    lunch_break:
      fromOrg.lunch_break && fromOrg.lunch_break.start && fromOrg.lunch_break.end
        ? { start: fromOrg.lunch_break.start, end: fromOrg.lunch_break.end }
        : null,
    timezone: fromOrg.timezone || DEFAULT_WORK_TIME.timezone,
  };
};

/**
 * Customer-facing planning communication (organization.settings.planning).
 * Everything defaults to OFF; the backend enforces the same defaults.
 */
export const DEFAULT_ORDER_CONFIRMATION_INTRO =
  'Bedankt voor uw opdracht. Hierbij bevestigen wij uw bestelling. ' +
  'Hieronder vindt u de specificaties zoals afgesproken; de ondertekende offerte ' +
  'vindt u als bijlage. Wij nemen contact met u op om de uitvoering in te plannen.';

export const DEFAULT_PLANNING_CUSTOMER_SETTINGS = {
  order_confirmation_enabled: false,
  order_confirmation_intro: DEFAULT_ORDER_CONFIRMATION_INTRO,
  customer_preference_enabled: false,
  appointment_confirmation_enabled: false,
  appointment_silent_accept_hours: 48,
};

/** Resolve customer planning settings from organization settings with defaults */
export const getPlanningCustomerSettings = (organization) => {
  const raw = organization?.settings?.planning;
  if (!raw || typeof raw !== 'object') return { ...DEFAULT_PLANNING_CUSTOMER_SETTINGS };
  return {
    order_confirmation_enabled: raw.order_confirmation_enabled === true,
    order_confirmation_intro:
      typeof raw.order_confirmation_intro === 'string' && raw.order_confirmation_intro.trim()
        ? raw.order_confirmation_intro
        : DEFAULT_ORDER_CONFIRMATION_INTRO,
    customer_preference_enabled: raw.customer_preference_enabled === true,
    appointment_confirmation_enabled: raw.appointment_confirmation_enabled === true,
    appointment_silent_accept_hours:
      raw.appointment_silent_accept_hours ??
      DEFAULT_PLANNING_CUSTOMER_SETTINGS.appointment_silent_accept_hours,
  };
};

export const STORAGE_KEY_PLANNING_WORK_TYPES = 'smartflow_planning_visible_work_types';
export const STORAGE_KEY_BULK_PLAN_FORM = 'smartflow_planning_bulk_plan_form';
/** @deprecated use STORAGE_KEY_BULK_PLAN_FORM */
export const STORAGE_KEY_BULK_DAY_FORM = STORAGE_KEY_BULK_PLAN_FORM;

/** Minimum time to show route planning overlay (ms) */
export const ROUTE_PLANNING_MIN_LOADING_MS = 3000;
